import { computed, ref } from 'vue';
import { ChecklistTemplateBuilderEditable } from '@/ui/DTO/checklistTemplateBuilderEditable';
import { InspectionActionLegacy, jsonInspectionActionToChecklistTemplateEditableAdaptor } from '@/ui/pages/checklist/adaptors/InspectionActionAdaptors';
import { ChecklistTemplateEditable } from '@/ui/DTO';

// state
export const checklists = ref<Array<ChecklistTemplateEditable>>([]);
export const undeletedChecklists = computed(() => checklists.value.filter(a => !a.softDeleted));
export const checklistBeingEdited = ref<ChecklistTemplateBuilderEditable | null>(null);

export const updateChecklist = (action: ChecklistTemplateEditable) => {
  checklists.value.splice(
    checklists.value.findIndex(a => a.internalId === action.internalId)!,
    1,
    {
      ...action,
      wasChanged: true,
    },
  );
};

export const addChecklist = (action: ChecklistTemplateEditable) => {
  checklists.value.push(action);
};

export const removeChecklist = (action: ChecklistTemplateEditable) => {
  checklists.value.splice(
    checklists.value.findIndex(a => a.internalId === action.internalId)!,
    1,
    {
      ...action,
      softDeleted: true,
    },
  );
};

export const setInspectionBeingEditedFromLegacy = (inspectionLegacy: InspectionActionLegacy) => {
  checklistBeingEdited.value = jsonInspectionActionToChecklistTemplateEditableAdaptor(inspectionLegacy);
};
